$(document).ready(function(){

    'use strict';


    // Open Search
    $("#input-search").on("click", function(e){

        e.preventDefault();
        e.stopPropagation();

        $(".content-search").css({
            "visibility": "visible",
            "opacity": "1",
            "display": "block",
            "pointer-events": "auto",
            "z-index": "999999"
        });


        $(".content-search input").prop("disabled", false);
        $(".content-search input").prop("readonly", false);

        setTimeout(function(){
            $(".content-search input").focus();
        },100);

    });



    // Close Search
    $("#close-search").on("click", function(e){

        e.preventDefault();
        e.stopPropagation();

        $(".content-search").css({
            "visibility": "hidden",
            "opacity": "0",
            "display": "none"
        });

    });



    // Keep Search Input Active
    $(document).on("click", ".control-search", function(e){
        e.stopPropagation();

        $(this).prop("disabled", false);
        $(this).prop("readonly", false);

        $(this).focus();
    });



    // Prevent Search Form Blocking
    $(document).on("click", ".content-search form", function(e){
        e.stopPropagation();
    });



    // Cart Menu
    $(".cart-menu").on("click", function(){

        $('.sidebar-cart')
        .css("right","0")
        .css("box-shadow","0 10px 20px 0");

    });



    // Close Cart
    $("#close-cart").on("click", function(){

        $('.sidebar-cart')
        .css("right","-260px")
        .css("box-shadow","unset");

    });


});